// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import infiniteScroll from 'vue-infinite-scroll'
import ElementUI from 'element-ui'
import util from './util'
import 'element-ui/lib/theme-chalk/index.css'
import 'assets/style/index.scss'
import VueLazyLoad from 'vue-lazyload'
import promise from 'es6-promise'
import VueClipboard from 'vue-clipboard2'

Vue.use(ElementUI)
Vue.use(infiniteScroll)
Vue.use(util)
Vue.use(VueLazyLoad, {
  error: require('assets/images/default.png'),
  loading: require('assets/images/default.png')
})
Vue.use(VueClipboard)

Vue.config.productionTip = false

window.platform = 'WEB'
window.maxNumber = 2147483647
window.maxTitle = '受系统压力影响，翻页统计功能已关闭'

// 添加全局变量
Vue.prototype.$PRIVACY_POLICY_URL = 'https://tup-jenkins.oss-cn-beijing.aliyuncs.com/appFile/business_privacy.pdf';



promise.polyfill()

Vue.directive('enterNumber2', {
  inserted (el) {
    el.addEventListener('keypress', e => {
      e = e || window.event
      let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      let re = /\d/
      if (charcode === 46) {
        if (el.value.includes('.')) {
          e.preventDefault()
        }
      } else if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
  }
})

window.addEventListener('storage', function (e) { // 防止一个浏览器多个tab串号
  if (e.key === 'TUP_token' && e.newValue !== e.oldValue) {
    window.alert('系统检测到你在浏览器登录多个账号，请关闭当前页面')
    router.go(0)
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js